export default __webpack_public_path__ + "static/media/2.b39c8d50.png";